export const data = [
  {
    id: 1,
    reminder_type: "service_reminder",
    associated_item: "Trailer #1000",
    address: "New York No. 1 Lake Park",
    due_date: "2022-04-01T00:00:00.000Z",
    priority: "High",
    status: "overdue",
  },
  {
    id: 2,
    reminder_type: "contact_renewal_reminder",
    associated_item: "Trailer #1030",
    address: "New York No. 1 Lake Park",
    due_date: "2022-04-01T00:00:00.000Z",
    priority: "High",
    status: "overdue",
  },
  {
    id: 3,
    reminder_type: "contact_renewal_reminder",
    associated_item: "Trailer #1400",
    address: "New York No. 1 Lake Park",
    due_date: "2022-04-01T00:00:00.000Z",
    priority: "High",
    status: "overdue",
  },
  {
    id: 4,
    reminder_type: "contact_renewal_reminder",
    associated_item: "Trailer #1003",
    address: "New York No. 1 Lake Park",
    due_date: "2022-04-01T00:00:00.000Z",
    priority: "High",
    status: "overdue",
  },
];

export const reminderTableHeads = [
  {
    label: "Reminder Type",
    id: "reminder_type",
  },
  {
    label: "Associated Item ",
    id: "associated_item",
  },
  {
    label: "Due Date",
    id: "due_date",
  },

  {
    label: "Status",
    id: "status",
  },
  {
    label: "Contact",
    id: "contact",
  },
];

export type ReminderType =
  | "service_reminder"
  | "vehicle_renewal"
  | "contact_renewal";
